import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './assets/sass/theme.scss';

const container = document.getElementById('app');
const root = createRoot(container!);
root.render(<App />);
